import React, { Component } from "react";
import PropTypes from "prop-types";
import LazyLoad from "react-lazyload";
import ShareButtons from "./ShareButtons";
import g from "../utils/globals";
import { isHomeMobile } from "../utils/helpers";
import { firstContentReady } from "../utils/api";
import "../../css/components/Img.scss";

class Img extends Component {
  constructor(props) {
    super(props);
    this.img = null;
  }
  shouldComponentUpdate = nextProps => nextProps.props !== this.props;

  pixelRatioImageHandler = attrs => {
    if (attrs) {
      const mustToReplace = g.pixelRatioImgs.find(image => attrs.id.indexOf(image.name) > -1);
      if (mustToReplace) {
        if (!this.props.isPicture) {
          attrs.src = attrs.src.replace(mustToReplace.toReplace, mustToReplace.replace);
        } else {
          Object.keys(this.props.sources).forEach(orientation => {
            this.props.sources[orientation].src.replace(mustToReplace.toReplace, mustToReplace.replace);
          });
        }
      }
    }
  };

  onLoad = () => firstContentReady(this.props);

  render = () => {
    const attrs = this.props.attrs;
    if (g.pixelRatioImgs) {
      this.pixelRatioImageHandler(attrs);
    }

    this.pixelRatioImageHandler();
    if (this.props.bounds && this.props.bounds.height) {
      attrs.height = `${this.props.bounds.height}%`;
    }
    const renderPicture = () => {
      const defaultSrc =
        !isHomeMobile() && this.props.sources.landscape ? this.props.sources.landscape.src : this.props.sources.portrait.src;
      return (
        <picture className="pictureWrapper">
          {Object.keys(this.props.sources).map((orientation, idx) => (
            <source key={idx} media={`(orientation: ${orientation})`} srcSet={this.props.sources[orientation].src} />
          ))}
          <img {...attrs} style={this.props.styles} src={defaultSrc} className="pictureImg" onLoad={this.onLoad} />
        </picture>
      );
    };

    const renderWithLazy = () => {
      return (
        <LazyLoad offset={1600} placeholder={<img {...attrs} style={{ ...this.props.styles }} src="" />}>
          <img {...attrs} style={this.props.styles} />
        </LazyLoad>
      );
    };
    const renderImg = () => {
      if (g.eagerMode) {
        return <img {...attrs} style={this.props.styles} onLoad={g.renderingCheck.add(attrs.src)} />;
      }
      if (this.props.isPicture) return renderPicture();
      return this.props.noLazy ? <img {...attrs} style={this.props.styles} /> : renderWithLazy();
    };
    // Carousel has own lazy
    // if (this.props.carousel) return <img {...attrs} />;

    if (this.props.attributes && this.props.attributes.social && this.props.attributes.social.id) {
      return <ShareButtons {...this.props}>{renderImg()}</ShareButtons>;
    }

    return renderImg();
  };
}

Img.defaultProps = {
  carousel: null,
  attrs: {
    src: "",
  },
};

Img.propTypes = {
  carousel: PropTypes.bool,
  attrs: PropTypes.shape({
    src: PropTypes.string,
  }),
};

export default Img;
